import { Button } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { EPOCUS_PRIMARY, rem } from "../../_lib/epocus-palette";
import { linkToEpocusSettings } from "../../links";

export const BackToSettingsLink: FC = () => {
  const navigate = useNavigate();
  return (
    <Button
      onClick={() => navigate(linkToEpocusSettings())}
      style={{
        color: EPOCUS_PRIMARY,
        textTransform: "none",
        fontSize: rem(14),
        padding: "4px 0",
        minWidth: 0,
        alignSelf: "flex-start",
      }}
    >
      ‹ Back to settings
    </Button>
  );
};
